import {useRef,useState,useEffect} from 'react';
import type {AgentTransport,AgentContext,AgentMessage} from '../domain/types';
import {translateAssistant} from '../i18n/auto-translate';
import {robotPhrase} from '../components/robotLocale';
export function useAgent(transport:AgentTransport,context:AgentContext){
 const welcome:AgentMessage={id:'welcome',role:'assistant',text:'Chào bạn. Tôi giúp bạn tìm nội dung NIBELC và chuẩn bị bước tiếp theo. Bạn muốn tìm hiểu việc làm, đào tạo hay hợp tác doanh nghiệp?'};
 const [messages,setMessages]=useState<AgentMessage[]>([{...welcome,text:context.locale==='vi'?welcome.text:robotPhrase(0,context.locale)}]);
 const [state,setState]=useState<'idle'|'sending'|'error'>('idle');
 const controller=useRef<AbortController|null>(null),conversation=useRef<AgentMessage[]>([welcome]),pending=useRef(false);
 async function display(items:AgentMessage[],signal:AbortSignal){
  const translated=await Promise.all(items.map(async m=>{
   if(m.role==='user')return m;
   try{return {...m,text:await translateAssistant(m.text,context.locale,signal),sources:await Promise.all((m.sources||[]).map(async s=>({...s,title:await translateAssistant(s.title,context.locale,signal)})))}}
   catch{signal.throwIfAborted();return {...m,text:robotPhrase(m.id==='welcome'?0:4,context.locale),sources:[]}}
  }));
  if(!signal.aborted)setMessages(translated);
 }
 useEffect(()=>{
  controller.current?.abort();pending.current=false;setState('idle');
  const c=new AbortController();controller.current=c;
  setMessages(conversation.current.map(m=>m.role==='user'?m:{...m,text:robotPhrase(m.id==='welcome'?0:5,context.locale),sources:[]}));
  void display(conversation.current,c.signal).catch(()=>{});
  return()=>{c.abort();controller.current?.abort();pending.current=false};
 },[transport,context.locale]);
 async function send(text:string){
  const value=text.trim();if(!value||pending.current)return;
  pending.current=true;
  const user:AgentMessage={id:crypto.randomUUID(),role:'user',text:value};
  const next=[...conversation.current,user];conversation.current=next;setMessages(old=>[...old,user]);setState('sending');
  controller.current?.abort();const c=new AbortController();controller.current=c;
  try{const message=await transport.send(next,context,c.signal);if(!c.signal.aborted){conversation.current=[...next,message];await display(conversation.current,c.signal);if(!c.signal.aborted)setState('idle')}}
  catch{if(!c.signal.aborted)setState('error')}
  finally{if(controller.current===c)pending.current=false}
 }
 function reset(){controller.current?.abort();pending.current=false;const c=new AbortController();controller.current=c;conversation.current=[{id:'reset',role:'assistant',text:'Một hành trình mới. Tôi có thể giúp bạn tìm gì?'}];setMessages([{...conversation.current[0],text:robotPhrase(5,context.locale)}]);setState('idle');void display(conversation.current,c.signal).catch(()=>{});}
 return {messages,state,send,reset};
}
